import ControlPanel from '@/components/monitoring/3d-revamp/control-panel';
import DataMonitoringPanel from '@/components/monitoring/3d-revamp/data-monitoring-panel';
import ModelLoader from '@/components/monitoring/3d-revamp/model-loader';
import Scene3D from '@/components/monitoring/3d-revamp/scene-3d';
import { Button } from '@/components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { DataProvider } from '@/contexts/data-context';
import { PerformanceProvider } from '@/contexts/performance-context';
import { SceneProvider } from '@/contexts/scene-context';
import { Canvas } from '@react-three/fiber';
import { createFileRoute } from '@tanstack/react-router';
import { Loader2, Menu, X } from 'lucide-react';
import { Suspense, useState } from 'react';

export const Route = createFileRoute('/_authenticated/(user-dashboard)/dashboard/_monitor-3d/monitor-3d')({
  component: RouteComponent,
});

function RouteComponent() {
  const [leftPanelOpen, setLeftPanelOpen] = useState(true);
  const [rightPanelOpen, setRightPanelOpen] = useState(true);

  return (
    <PerformanceProvider>
      <SceneProvider>
        <DataProvider>
          <div className="h-screen flex flex-col bg-background text-foreground overflow-hidden">
            {/* Navigation Bar */}
            {/* <NavigationBar /> */}

            {/* Main Content */}
            <div className="flex-1 flex relative overflow-hidden">
              {/* Left Panel - Controls */}
              <div
                className={`${
                  leftPanelOpen ? 'w-80' : 'w-0'
                } bg-card border-r border-border transition-all duration-300 ease-in-out overflow-hidden flex flex-col`}
              >
                <div className="flex-1 flex flex-col min-h-0 overflow-hidden">
                  <div className="p-4 border-b border-border flex-shrink-0">
                    <h3 className="text-lg font-semibold">Controls</h3>
                  </div>
                  <div className="flex-1 p-4 overflow-hidden">
                    <Tabs defaultValue="model" className="h-full flex flex-col">
                      <div className="flex-shrink-0">
                        <TabsList className="w-full">
                          <TabsTrigger value="model" className="flex-1">
                            Model
                          </TabsTrigger>
                          <TabsTrigger value="scene" className="flex-1">
                            Scene
                          </TabsTrigger>
                          <TabsTrigger value="sensors" className="flex-1">
                            Sensors
                          </TabsTrigger>
                        </TabsList>
                      </div>
                      <div className="flex-1 mt-4 overflow-hidden">
                        <TabsContent value="model" className="h-full">
                          <div className="h-full overflow-y-auto">
                            <ModelLoader />
                          </div>
                        </TabsContent>
                        <TabsContent value="scene" className="h-full">
                          <div className="h-full overflow-y-auto">
                            <ControlPanel />
                          </div>
                        </TabsContent>
                        <TabsContent value="sensors" className="h-full">
                          <div className="h-full overflow-y-auto">
                            <div className="space-y-4">
                              <h3 className="text-lg font-semibold">Sensor Configuration</h3>
                              {/* Sensor configuration will be added here */}
                            </div>
                          </div>
                        </TabsContent>
                      </div>
                    </Tabs>
                  </div>
                </div>
              </div>

              {/* Toggle button for left panel */}
              <Button
                variant="ghost"
                size="icon"
                className="absolute top-2 right-2 z-10 bg-background/80 backdrop-blur-sm"
                onClick={() => setLeftPanelOpen(!leftPanelOpen)}
              >
                {leftPanelOpen ? <X className="h-4 w-4" /> : <Menu className="h-4 w-4" />}
              </Button>

              {/* Main 3D Viewport */}
              <div className="flex-1 relative">
                <Canvas camera={{ position: [5, 5, 5], fov: 60 }} shadows className="bg-black/90">
                  <Suspense fallback={null}>
                    <Scene3D />
                  </Suspense>
                </Canvas>

                {/* Loading indicator */}
                <div className="absolute top-4 left-1/2 -translate-x-1/2 flex items-center gap-2 bg-background/80 backdrop-blur-sm px-3 py-2 rounded-full">
                  <Loader2 className="w-4 h-4 animate-spin" />
                  <span className="text-sm">Rendering Scene</span>
                </div>
              </div>

              {/* Toggle button for right panel */}
              <Button
                variant="ghost"
                size="icon"
                className="absolute top-2 left-2 z-10 bg-background/80 backdrop-blur-sm"
                onClick={() => setRightPanelOpen(!rightPanelOpen)}
              >
                {rightPanelOpen ? <X className="h-4 w-4" /> : <Menu className="h-4 w-4" />}
              </Button>

              {/* Right Panel - Data Monitoring */}
              <div
                className={`${
                  rightPanelOpen ? 'w-96' : 'w-0'
                } bg-card border-l border-border transition-all duration-300 ease-in-out overflow-hidden flex flex-col`}
              >
                <div className="h-full overflow-hidden">
                  <DataMonitoringPanel />
                </div>
              </div>
            </div>
          </div>
        </DataProvider>
      </SceneProvider>
    </PerformanceProvider>
  );
}
